/**
 * Sorts an array alphabetically by a given key (for arrays of objects)
 * or directly (for arrays of primitives when key is null).
 *
 * Callers that need pinned static options (e.g. "None", "All Categories") should
 * keep those entries outside this helper and append/prepend them after sorting.
 *
 * @param {Array} arr - The array to sort.
 * @param {string|null} key - The object property to sort by, or null for primitive arrays.
 * @returns {Array} A new sorted array (does not mutate the original). Non-array input is returned unchanged.
 */
export const sortAlphabetically = (arr, key = 'name') => {
    if (!Array.isArray(arr)) {
        return arr;
    }

    return [...arr].sort((a, b) => {
        const left = key ? String(a[key] ?? '') : String(a ?? '');
        const right = key ? String(b[key] ?? '') : String(b ?? '');
        return left.localeCompare(right);
    });
};
